import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppCommon } from '../../providers/app-common';
import { NzModalService } from 'ng-zorro-antd/modal';
import { VendorViewModel } from '../../models-views/vendor.view.model';

@Component({
  selector: 'app-vendor-poc-details',
  standalone: false,
  templateUrl: './vendor-poc-details.component.html',
  styleUrl: './vendor-poc-details.component.scss'
})
export class VendorPocDetailsComponent {
  @Input() poc_details: any[] = [];
  @Input() showActions: boolean = true;
  @Input() isVisible: boolean = false;
  @Output() closePoc: EventEmitter<Boolean> = new EventEmitter<Boolean>()
  @Output() editPocEvent: EventEmitter<any> = new EventEmitter<any>() 
  @Output() pocDeletedEvent: EventEmitter<Boolean> = new EventEmitter<Boolean>()
  loggedInUser: any

  constructor(private vm: VendorViewModel, private modal: NzModalService) {
    this.loggedInUser = AppCommon.getloggedInObject().user
  }

  ngOnInit(): void {
    this.vm.vendorPocDetailsComponent = this
  }


  deletePOC(poc: any) {
    this.modal.confirm({
      nzTitle: 'Are you sure delete "' + poc.poc_name + '"?',
      nzContent: '<b style="color: red;">If you delete this, you will no longer be able restore it.</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this.vm.deletePOC(poc.id),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });

  }

  pocDeleted(deleteId: number) {
    this.poc_details = this.poc_details.filter(el => el.id !== deleteId);
    if(this.poc_details.length === 0){
      this.isVisible = false;
      this.closePoc.emit(true);
    } else {
      this.pocDeletedEvent.emit(true);
    }
  }

  handleOk(): void {
    this.isVisible = false;
    this.closePoc.emit(false)
  }

  handleCancel(): void {
    this.isVisible = false;
    this.closePoc.emit(false)
  }

  editPOC(poc: any) {
    this.editPocEvent.next(poc);
  }

pocUpdated(){
  this.closePoc.emit(false)
}
  
}
